module.exports = __webpack_public_path__ + "img/weight-hanging.6e7e03b2.svg";